export default __webpack_public_path__ + "static/media/Button.d6e4dc46.svg";